import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

const MatchScoreIndicator = ({ score, maxScore, textColor = 'text.secondary' }) => {
  // If maxScore is 0 or less, it means no common movies, so we show nothing or a zero state.
  if (maxScore <= 0) {
    return (
      <Box sx={{ width: '100%', my: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          Rate more movies to see your match score.
        </Typography>
      </Box>
    );
  }

  // Normalize score to a 1-10 scale for display
  const normalizedScore = 1 + (score / maxScore * 9);
  
  // Clamp the value between 0 and 1 for color calculation and progress bar
  const percentage = Math.max(0, Math.min(1, score / maxScore));

  // Interpolate color from light orange-peach to purple using HSL for a smooth gradient
  const hue = 30 + (240 * percentage);
  const saturation = 100 - (40 * percentage);
  const lightness = 85 - (15 * percentage);
  const barColor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

  return (
    <Box sx={{ width: '100%', my: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="body2" color={textColor} sx={{ fontWeight: 'medium' }}>
          Match Score
        </Typography>
        <Typography variant="h6" component="span" sx={{ color: barColor, fontWeight: 'bold' }}>
          {normalizedScore.toFixed(1)}
          <span style={{ fontSize: '0.8rem', color: 'grey' }}> / 10</span>
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={normalizedScore * 10}
        sx={{
          height: 12,
          borderRadius: 6,
          '& .MuiLinearProgress-bar': {
            backgroundColor: barColor,
            borderRadius: 6,
          },
          backgroundColor: (theme) => theme.palette.grey[200],
        }}
      />
    </Box>
  );
};

export default MatchScoreIndicator;